import React from 'react'
import { Container } from 'react-bootstrap'
import Navbar from './Navbar'

function Layout({ children }) {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--color-background)' }}>
      <Navbar />
      <Container fluid className="py-4">
        {children}
      </Container>
    </div>
  )
}

export default Layout
